import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';

const useManagePremiumStoreInfo = () => {
  const navigate = useNavigate();
  const { mutateAsync, isPending } = useMutation('managePremiumStoreInfo', {
    onSuccess: async (res) => {
      toast.success(res.message || 'Premium store information updated successfully');
      void navigate({ to: '/store-information/premium-stores' });
      await revalidate(['hostDetail', 'clubHosts', 'clubBasicInfo', 'all']);
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to update premium store information');
    },
  });
  return { mutateAsync, isPending };
};

export default useManagePremiumStoreInfo;
